// contributor: https://51degrees.com/blog/website-optimisation-for-apple-devices-ipad-and-iphone

import { gradeAndroid } from './androidUtils.js'
import { getiPhoneModel, getiPadModel } from './appleUtils.js'

export const DeviceGrades = {
    A: 'A',
    C: 'C',
    F: 'F',
    NOT_TESTED: 'NOT-TESTED',
}

export const getOS = function() {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'mac'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'ios'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'windows'
    } else if (/Android/.test(userAgent)) {
        os = 'android'
    } else if (!os && /Linux/.test(platform)) {
        os = 'linux'
    }

    return os
}

var setBrowser = function(details) {
    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0
    if (isOpera) details.browser = 'opera'

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined'
    if (isFirefox) details.browser = 'firefox'

    // Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function(p) {
            return p.toString() === '[object SafariRemoteNotification]'
        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))
    if (isSafari) details.browser = 'safari'

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ false || !!document.documentMode
    if (isIE) details.browser = 'ie'

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia
    if (isEdge) details.browser = 'edge'

    // Chrome 1+
    var isChrome = !!window.chrome
    // Commented out b/c gives false negative on mobile
    // && !!window.chrome.webstore
    if (isChrome) details.browser = 'chrome'

    // Blink engine detection
    // var isBlink = (isChrome || isOpera) && !!window.CSS;
    // if(isBlink) details.browser = 'blink';

    return details
}

var checkForWebVR = function(details) {
    var supportsVR = navigator.getVRDisplays !== undefined
    details.webVR = supportsVR
    return details
}

// Establishes base object and gives gpu
var getBaseDetails = function() {
    var details = {
        deviceName: '',
        type: '',
        platform: '',
        browser: '',
        grade: DeviceGrades.NOT_TESTED,
        gpu: '',
        os: getOS(),
        ram: '',
        webVR: false,
    }
    // Create a canvas element which can be used to retreive information about the GPU.
    var canvas = document.createElement('canvas')
    if (canvas) {
        var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        if (context) {
            var info = context.getExtension('WEBGL_debug_renderer_info')
            if (info) {
                var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL)
                details.gpu = renderer
            }
        }
    }

    return details
}

var explainGrade = function(deviceDetails) {
    var letterGrade = deviceDetails.grade
    var type = deviceDetails.type

    var details = {
        A: {
            class: 'error',
            text: 'Fully supported',
            version: 'full',
        },
        C: {
            class: 'error',
            text: 'Degraded Experience',
            version: 'degraded',
        },
        F: {
            class: 'error',
            text: 'You are using an unsupported device, proceed at your own risk',
            version: 'minimum',
        },

        'N/A': {
            class: 'error',
            text: 'You are using an untested device, with all features enabled',
            version: 'full',
        },
    }

    var data = details[letterGrade]
    var html = data.text
    switch (type) {
        case 'ipad':
            data = details[letterGrade]
            html = data.text

            break
        default:
            data = details[letterGrade]
            html = data.text
    }

    deviceDetails.gradeExplain = html

    deviceDetails.version = data.version
    return deviceDetails
}

// Gives base details, then fills out with available info based on platform, browser, etc.
var getDeviceDetails = function() {
    var details = getBaseDetails()
    if (details.os === 'ios') {
        if (details.type === 'ipad') {
            details = Object.assign(details, getiPadModel())
        } else {
            details = Object.assign(details, getiPhoneModel())
        }
    } else {
        details.grade = gradeAndroid()
    }

    details = Object.assign(details, setBrowser(details))
    details = Object.assign(details, checkForWebVR(details))

    if (details.os === 'mac' || details.os === 'windows') {
        details.type = 'desktop'
    } else {
        details.type = 'mobile'
    }
    details = Object.assign(details, explainGrade(details))

    return details
}

export default getDeviceDetails
